import dayjs from "dayjs";
import DateDisplay from "$lib/components/ui/DateDisplay.svelte";
import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
import NumberInput from "$lib/components/ui/NumberInput.svelte";
import TimeInput from "$lib/components/ui/TimeInput.svelte";
import Select from "$lib/components/ui/Select.svelte";
import DateTimeInput from "$lib/components/ui/DateTimeInput.svelte";
import EmployeeName from "$lib/components/ui/EmployeeName.svelte";


export let ReadWorkEntries = (qualifications: Array<any>): Array<SortableTableHeaderElement> => {
    let header = [
        {
            label: 'Anzahl',
            property: 'amount',
            class: 'w-1/7',
        },
        {
            label: 'Qualifikation',
            property: 'qualificationId',
            render: (project: any) => qualifications.find(x => x.id === project.qualificationId)?.title

        },
        {
            label: 'Tag',
            property: 'startsAt',
            component: DateDisplay
        },
        {
            label: 'Von',
            property: 'startsAt',
            render: (project: any) => dayjs(project.startsAt.value || project.startsAt).format('HH:mm [Uhr]'),
        },
        {
            label: 'Bis',
            property: 'endsAt',
            render: (project: any) => dayjs(project.endsAt.value || project.endsAt).format('HH:mm [Uhr]')
        },

    ]
    return header;
}

export let ReadAssignments = (project: any, assignments: Array<any>): Array<SortableTableHeaderElement> => ([
    {
        label: 'Mitarbeiter',
        property: 'index',
        component: EmployeeName,
        props: {
            getEmployeeId: (index: number) => assignments[index].employeeId,
            projectUuid: project.uuid
        }

    },
    {
        label: 'Von (soll)',
        property: 'plannedStart',
        render: (assignment: any) => dayjs(assignment.plannedStart.value).format('HH:mm [Uhr]')

    },
    {
        label: 'Bis (soll)',
        property: 'plannedEnd',
        render: (assignment: any) => dayjs(assignment.plannedEnd.value).format('HH:mm [Uhr]')
    },
    {
        label: 'Von (ist)',
        property: 'actualStart',
        render: (assignment: any) => assignment.actualStart.value ? dayjs(assignment.actualStart.value).format('HH:mm [Uhr]') : ''
    },
    {
        label: 'Bis (ist)',
        property: 'actualEnd',
        render: (assignment: any) => assignment.actualEnd.value ? dayjs(assignment.actualEnd.value).format('HH:mm [Uhr]') : ''
    },
])

export let EditWorkEntries = (qualifications: Array<any>, project: any, reactive: any): Array<SortableTableHeaderElement> => {
    let header = ReadWorkEntries(qualifications);

    header = header.map((item: SortableTableHeaderElement, index: number) => {
        switch (index) {
            case 0:
                item.component = NumberInput;
                break;
            case 1:
                item.component = Select;
                item.props = {
                    options: qualifications.map(x => {
                        return {
                            value: x.id,
                            label: x.title
                        }
                    })
                }
                break;
            case 4:
                let days = [];
                const start = dayjs(typeof project.startsAt.value !== 'undefined' ? project.startsAt.value : project.startsAt);
                const diff = dayjs(typeof project.endsAt.value !== 'undefined' ? project.endsAt.value : project.endsAt).diff(start, 'day')
                if (diff > 0) {
                    item.component = Select;
                    for (let i = 0; i <= diff; i++) {
                        const current = start.add(i, 'day')
                        days.push({
                            value: current.format('YYYY-MM-DD'),
                            label: current.format('DD.MM.YYYY')
                        })
                    }
                    item.props = {
                        options: days
                    }
                } else {
                    delete item.component;
                    item.render = () => '<div class="pt-4">' + dayjs(project.startsAt.value || project.startsAt).format('DD.MM.YYYY') + '</div>'
                }


                break;
            default:
                item.component = TimeInput;
                break;

        }
        return item;
    });
    header.push({
        label: 'Entfernen',
        property: 'index',
        component: RemoveButton,
        props: {
            onClick: reactive.delete,
            classes: 'text-center pt-4'
        },
        class: 'w-8',
        movable: false,
        sortable: false
    })
    return header;
}